import React, { useState, useEffect } from "react";
import Loadspinner from "../../common/Loadspinner";
import Main from "../../common/Main/Main";
//import DatePicker from "react-horizontal-datepicker";
// import ReactHorizontalDatePicker from "react-horizontal-strip-datepicker";
// import "react-horizontal-strip-datepicker/dist/ReactHorizontalDatePicker.css";
import { DayPicker, DayContent } from "react-day-picker";
import notify from "../../ReusableComponents/ToastNotification/ToastNotification";
import "react-day-picker/dist/style.css";
import { format } from "date-fns";
import CalendarService from "../../services/CalendarService";
import "./Calandar.css";
import Avatar from "react-avatar";
import { Modal, Typography } from "@material-ui/core";
import { getEventData, getUpcomingData } from "../../helpers/API/APIEndPoints";
import { APICall } from "../../helpers/API/APICalls";
import { downloadBlob } from "../../services/CommonService";
import Button from "react-bootstrap/Button";
import { OverflowTip } from "../../ReusableComponents/OverFlowTip/OverflowTip";
import ImageViewer from "react-simple-image-viewer";
import ImageLightBox from "../EventGallery/ImageLightBox";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { addMonths } from "date-fns";
import moment from "moment";
import { Card, CardContent, CardMedia, Chip, Divider } from "@mui/material";

import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { borderRadius } from "@mui/system";
import { replaceImgAccountName } from "../../helpers/Utils/Utils";
import ImageIcon from "@mui/icons-material/Image";
import CommonConstants from "../../constants/CommonConstants";

function Calandar() {
  const [isLoading, setLoading] = useState(false);
  const [selectedDate, setSelDate] = useState(null);
  const [selectedDate2, setSelDate2] = useState(null);
  const [eventList, setEventsList] = useState([]);
  const [eventData, setEventData] = useState([]);
  const [showModal, setShowModal] = useState("");
  const [currImg, setCurrImg] = useState();
  const [index, setIndex] = useState();
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [images, setimages] = useState([]);
  const [key, setKey] = useState();
  const nextMonth = addMonths(new Date(), 1);
  const [year, setYear] = useState();

  const [files, setFiles] = useState([]);
  let details = [];
  var dates = [];

  // useEffect(() => {
  // console.log(eventList);
  //   let today = new Date().toISOString().slice(0, 10);
  //   getEventDetails(today);
  // }, []);

  useEffect(() => {
    getUpcomingEventsDetails();
  }, []);

  // const getEventDetails = async (eventDate) => {
  //   setLoading(true);
  //   let reqBody = {
  //     activity_date: eventDate,
  //   };
  // }

  const getEventDateRangeFormatted = (startDate, endDate) => {
    let dateStr = '';
    const startDateObj = moment(startDate, 'YYYY-MM-DD');
    const endDateObj = moment(endDate, 'YYYY-MM-DD');

    if (startDateObj.isValid() && endDateObj.isValid()) {
      const daysDiff = endDateObj.diff(startDateObj, 'days');
      const monthsDiff = endDateObj.diff(startDateObj, 'months');
      const yearsDiff = endDateObj.diff(startDateObj, 'years');

      if (yearsDiff !== 0) {
        dateStr = `${startDateObj.format('D MMM YYYY')} to ${endDateObj.format('D MMM YYYY')}`;
      } else if (monthsDiff !== 0) {
        dateStr = `${startDateObj.format('D MMM')} to ${endDateObj.format('D MMM YYYY')}`;
      } else if (daysDiff !== 0) {
        dateStr = `${startDateObj.format('D')} to ${endDateObj.format('D MMM YYYY')}`;
      } else {
        dateStr = startDateObj.format('D MMM YYYY');
      }
    }

    return dateStr;
  };

  const getEventDatas = async (startdate) => {
    setLoading(true);
    let reqBody = {
      StartDate: startdate,
    };
    //console.log(reqBody);
    const data = await APICall(getEventData, reqBody, "POST");
    //console.log(data);
    if (data.message === "Ok") {
      let dataArr = data.data[0];
      let dataObj = dataArr[0];
      let filesTmp = [];
      let dt = [];
      let sampdata = [];
      setFiles(filesTmp);
      for (let index = 0; index < dataArr?.length; index++) {
        dataObj = dataArr?.[index];
        if (dataObj && dataObj?.docUrl) {
          const newDocUrl = replaceImgAccountName(dataObj?.docUrl);
          const fullResImgUrl = await downloadBlob(newDocUrl);

          const azureFileName = new URL(dataObj?.docUrl)?.pathname
            ?.split("/")
            ?.pop();
          // let arr = {
          //   title : dataObj.activity_title,
          //   desc : dataObj.activity_desc,
          //   starttime:dataObj.activity_start_time,
          //   endtime:dataObj.activity_end_time,
          //   location : dataObj.Location,
          //   Venue: dataObj.Venue,
          //   docid :dataObj.DocTypeDataId
          // }

          filesTmp.push({
            localUrl: null,
            blob: null,
            id: dataObj.docid || `img_${index}`,
            name: dataObj.DocName,
            size: null,
            type: dataObj.docExtension,
            globalUrl: fullResImgUrl,
            azureFileName: azureFileName,
            exists: true,
            docid: dataObj.DocTypeDataId,

            //   // title: dataObj.activity_title,
            //   // desc:dataObj.activity_desc,
            //   // starttime:dataObj.activity_start_time,
            //   // endtime:dataObj.activity_end_time,
            //   // location:dataObj.Location,
            //   // venue:dataObj.Venue
          });
          // filesTmp.push(arr);
        }
      }
      //  setFiles(filesTmp);
      //console.log(filesTmp);

      for (let index = 0; index < dataArr?.length; index++) {
        dataObj = dataArr?.[index];

        dt.push({
          id: dataObj.Id,
          title: dataObj.activity_title,
          desc: dataObj.activity_desc,
          starttime: dataObj.activity_start_time,
          endtime: dataObj.activity_end_time,
          startdate: dataObj.activity_start_date || '',
          enddate: dataObj.activity_end_date || '',
          eventDate: getEventDateRangeFormatted(dataObj.activity_start_date, dataObj.activity_end_date),
          location: dataObj.Location,
          venue: dataObj.Venue,
        });
      }
      //console.log(dt);

      for (let index = 0; index < dt.length; index++) {
        var key1, value1, arr;
        var val = [];
        if (sampdata.length === 0) {
          key1 = {
            id: dt[index].id,
            title: dt[index].title,
            desc: dt[index].desc,
            starttime: dt[index].starttime,
            endtime: dt[index].endtime,
            startdate: dt[index].startdate,
            enddate: dt[index].enddate,
            eventDate: getEventDateRangeFormatted(dataObj.activity_start_date, dataObj.activity_end_date),
            location: dt[index].location,
            venue: dt[index].venue,
          };
          for (let i = 0; i < filesTmp.length; i++) {
            if (filesTmp[i].docid == dt[index].id) {
              value1 = {
                localUrl: filesTmp[i].localUrl,
                blob: filesTmp[i].blob,
                id: filesTmp[i].id,
                name: filesTmp[i].name,
                size: filesTmp[i].size,
                type: filesTmp[i].type,
                globalUrl: filesTmp[i].globalUrl,
                azureFileName: filesTmp[i].azureFileName,
                exists: true,
                docid: filesTmp[i].docid,
              };
              val.push(value1);
            }
          }
          arr = {
            key: key1,
            value: val,
          };
          sampdata.push(arr);
        } else {
          if (!sampdata.find((m) => m.key.id == dt[index].id)) {
            key1 = {
              id: dt[index].id,
              title: dt[index].title,
              desc: dt[index].desc,
              starttime: dt[index].starttime,
              endtime: dt[index].endtime,
              startdate: dt[index].startdate,
              enddate: dt[index].enddate,
              eventDate: getEventDateRangeFormatted(dataObj.activity_start_date, dataObj.activity_end_date),
              location: dt[index].location,
              venue: dt[index].venue,
            };
            for (let i = 0; i < filesTmp.length; i++) {
              if (filesTmp[i].docid == dt[index].id) {
                value1 = {
                  localUrl: filesTmp[i].localUrl,
                  blob: filesTmp[i].blob,
                  id: filesTmp[i].id,
                  name: filesTmp[i].name,
                  size: filesTmp[i].size,
                  type: filesTmp[i].type,
                  globalUrl: filesTmp[i].globalUrl,
                  azureFileName: filesTmp[i].azureFileName,
                  exists: true,
                  docid: filesTmp[i].docid,
                };
                val.push(value1);
              }
            }
            arr = {
              key: key1,
              value: val,
            };
            sampdata.push(arr);
          }
        }
      }
      //console.log(sampdata);
      setEventData(sampdata);
    } else {
      notify(1, data.message);
      setLoading(false);
    }
    setLoading(false);
  };

  // useEffect(() => {
  //   eventData.map((event, index) => {
  //     let link = {
  //       key: event.key.id,
  //       value: [event.value],
  //     };
  //     imgs.push(link);
  //   });
  // }, [eventData]);

  //  setEventData(dt);
  // setEventData(data.data[0]);
  // const changeYear = async () => {
  //   setYear;
  //   console.log(moment(year).format("YYYY"),'yers')
  //   if(moment(year).format("YYYY") != moment(new Date()).format("YYYY")){
  //     await  getUpcomingEventsDetails();
  //   }
  // }
  useEffect(async () => {
    if (moment(year).format("YYYY") != moment(new Date()).format("YYYY")) {
      await getUpcomingEventsDetails();
    } else {
      await getUpcomingEventsDetails();
    }
  }, [year]);

  const getUpcomingEventsDetails = async () => {
    setLoading(true);
    let d = moment(year).format("YYYY");

    let req = {
      year: d,
    };

    // const resp = await CalendarService.getUpcomingEvents();
    const resp = await APICall(getUpcomingData, req, "POST");
    if (resp.message === "Ok") {
      let respData = resp.data[0];
      if (respData) {
        let uniqueEventDates = Array.from(
          new Set(respData.map((e) => e.activity_start_date))
        ).map((d) => new Date(d));
        setEventsList(uniqueEventDates);
      }
    }
    setLoading(false);
  };

  const onSelectedDay = async (d) => {
    let reqDate = format(new Date(d), "yyyy-MM-dd");
    setSelDate(format(new Date(reqDate), "dd-MM-yyyy"));
    setSelDate2(new Date(reqDate));
    //  getEventDetails(reqDate);
    await getEventDatas(reqDate);
  };
  // dates =
  //   eventList.length > 0
  //     ? eventList.map((e) => new Date(e.activity_start_date))
  //     : "";
  const modifiers = {
    today: new Date(),
    selectedDate2: selectedDate2,
    futureDate: eventList,
  };

  const modifiersStyles = {
    today: {
      fontWeight: "bold",
      color: "var(--theme-red)",
      backgroundColor: "rgba(0,0,0,0.3)",
    },
    selectedDate2: {
      outline: "var(--theme-red) auto 1px",
    },
    // futureDate: {
    //   fontWeight: "bold",
    //   //fontSize: "140%",
    //   //  color: "orange",
    //   // icon : <i className="fa-solid fa-circle"></i>
    //   textEmphasisStyle: "circle",
    //   textEmphasisPosition: "under left",
    //   textEmphasisColor: "var(--theme-red)",
    // },
  };
  const openNextImage = async () => {
    const nextIndex = index + 1;
    setIndex((prevCount) => prevCount + 1);
    //const imgUrl = eventGalleryData?.find(egd => egd.key == currentGalleryId)?.values?.[nextIndex]?.docUrl;
    const url = eventData.find((e) => e.key.id == key).value[nextIndex]
      ?.globalUrl;
    if (url) {
      // const buildImageUrl = await downloadBlob(imgUrl);
      setCurrImg(url);
    }
  };

  const openPrevImage = async () => {
    const nextIndex = index - 1;
    setIndex((prevCount) => prevCount - 1);
    const imgUrl = eventData?.find((e) => e.key.id == key)?.value[nextIndex]
      ?.globalUrl;
    if (imgUrl) {
      setCurrImg(imgUrl);
    }
  };

  if (eventData.length > 0) {
    eventData.map((event, index) => {
      // files.map((file)=>{
      let eventdetails = (
        <Card sx={{ maxWidth: 200, margin: 1, padding: 0 }} elevation={5}>
          <div style={{ position: "relative" }}>
            {event?.value?.[0]?.globalUrl ? (
              <CardMedia
                sx={{ height: 140 }}
                image={event?.value?.[0]?.globalUrl} //event?.value[0].localUrl || event?.value[0].globalUrl
                className="card-img"
                onClick={() => {
                  setIsViewerOpen(true);
                  setCurrImg(event?.value[0].globalUrl);
                  setIndex(0);
                  setKey(event.key.id);
                }}
                src={event?.value?.[0]?.globalUrl}
                crossorigin="anonymous"
              />
            ) : (
              <div className="d-flex justify-content-center">
                <ImageIcon
                  style={{ width: "10rem", height: "10rem" }}
                  color="disabled"
                />
              </div>
            )}
            <span
              style={{
                position: "absolute",
                bottom: 0,
                right: 0,
                margin: "0.5rem",
                color: "white",
                textShadow: "0 0 4px black",
                display: "none",
              }}
            >
              {event?.value?.length}
            </span>
          </div>

          <CardContent>
            <Typography variant="h6" component="span">
              {event.key.title}
            </Typography>
            <Divider variant="fullWidth" />
            <div className="py-2" style={{ color: "grey" }}>
              <OverflowTip>
                <Typography
                  variant="subtitle1"
                  component={"span"}
                  noWrap={false}
                >
                  {event.key.desc}
                </Typography>
              </OverflowTip>
            </div>
            {(event.key.eventDate) &&
              <Chip
                icon={<CalendarMonthIcon />}
                size="small"
                className="dtime mb-2"
                variant="outlined"
                color="success"
                // style= {{fontFamily:"Roboto  sans-serif;"}}
                label={event.key.eventDate}
              />}
            <Chip
              icon={<AccessTimeIcon />}
              size="small"
              className="dtime mb-2"
              variant="outlined"
              color="success"
              // style= {{fontFamily:"Roboto  sans-serif;"}}
              label={event.key.starttime + " - " + event.key.endtime}
            />
            <Typography variant="body2" color="text.secondary">
              <LocationOnIcon fontSize="small" />
              {event.key.venue} - {event.key.location}
            </Typography>
          </CardContent>
        </Card>
      );

      details.push(eventdetails);
    });
    // })
  }

  //console.log(moment(year).format("YYYY"))
  return (
    <Main active={"calendar"}>
      {/* {console.log(eventList)} */}
      <Loadspinner filename="Calandar.js" isLoading={isLoading} isMiddle="true" />
      <div className="display-row justify-space-between">
        {eventList.length > 0 ? (
          <div className="card cal-card">
            <div className="card-body" style={{ margin: "auto" }}>
              <h5 style={{ margin: "18px", fontWeight: 700 }}>Calender</h5>
              <label style={{ marginLeft: "20px", fontWeight: 600 }}>
                Select a date
              </label>
              <div className="input-group">
                <input
                  type="text"
                  style={{
                    margin: "5px 20px 1vh 20px",
                  }}
                  value={selectedDate}
                  className="form-control"
                  autoComplete={CommonConstants.autoCompleteInput}
                />
              </div>
              <DayPicker
                selectedDays={selectedDate}
                onDayClick={onSelectedDay}
                modifiers={modifiers}
                modifiersStyles={modifiersStyles}
                onMonthChange={setYear}
                modifiersClassNames={{
                  futureDate: "calendar-event-dates",
                }}
              //  onNextClick={()=>changeYear()}
              // showNextMonth={()=>changeYear()}
              />
            </div>
          </div>
        ) : null}
        <div className="card event-card">
          <div className="display-row justify-space-between">
            {selectedDate == null ? (
              <h5 className="card-title event-heading">Upcoming Events</h5>
            ) : (
              <h5 className="card-title event-heading">
                Events for {selectedDate}
              </h5>
            )}
          </div>

          {eventData.length > 0 ? (
            <div style={{ overflowY: "auto", height: "30vw", padding: "1rem" }}>
              <div className="container">
                <div className="row">{details}</div>
              </div>
            </div>
          ) : (
            <div className="no-events">
              <h5>No events found</h5>
            </div>
          )}
        </div>
      </div>
      {isViewerOpen && (
        <ImageLightBox
          isImageOpen={isViewerOpen}
          src={currImg ? currImg : eventData?.[0]?.value?.[0]?.globalUrl}
          alt="iamge"
        >
          <div
            onClick={() => setIsViewerOpen(false)}
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              zIndex: 100,
              cursor: "pointer",
              color: "whitesmoke",
            }}
          >
            <CloseIcon />
          </div>

          {index <
            eventData?.find((egd) => egd.key.id == key)?.value?.length - 1 && (
              <div
                onClick={openNextImage}
                style={{
                  position: "absolute",
                  top: "50%",
                  right: 10,
                  zIndex: 100,
                  cursor: "pointer",
                  color: "whitesmoke",
                }}
              >
                <ArrowForwardIosIcon />
              </div>
            )}
          {index > 0 && (
            <div
              onClick={openPrevImage}
              style={{
                position: "absolute",
                top: "50%",
                left: 10,
                zIndex: 100,
                cursor: "pointer",
                color: "whitesmoke",
              }}
            >
              <ArrowBackIosNewIcon />
            </div>
          )}
        </ImageLightBox>
      )}
    </Main>
  );
}

export default Calandar;
